<template>
  <div>

    <div class="row">
      <div class="col-3">
        <h4 class="font-weight-bold ">موجودی انبار: {{ row.product.stock }}</h4>
      </div>
      <div class="col-3">
        <h4 class="font-weight-bold ">کسری موجودی: {{ row.stockOut }}</h4>
      </div>
      <div class="col-3">
        <h4 class="font-weight-bold ">در دست تولید: {{ row.worksCount }}</h4>
      </div>

      <div class="col-3">
        <div class="row">
          <!--<div class="col">-->
            <!--<button class="btn btn-warning btn-block" @click="getPatterns(row.product.id)">تولید</button>-->
          <!--</div>-->
          <div class="col">
            <button class="btn btn-warning btn-block" @click="onTaminClicked(row.product.id)">تامین</button>
            <!--<router-link :to="'/production-management/supply/' + row.product.id" class="btn btn-info btn-block">تامین-->
            <!--</router-link>-->
          </div>
        </div>
      </div>
      <div class="col-12 m-3">
        <h4 class="font-weight-bold ">توضیحات: {{ row.description }}</h4>
      </div>
    </div>


    <b-modal id="modal-center"
             ref="productOrder"
             v-if="showModal === true"
             centered
             size="lg"
             title="دستور تولید"
             :ok-title="'ذخیره'"
             :cancel-title="'لغو'"
             @ok="sendOrderToProduce"
    >
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>الگوی تولید</span>
              </div>
            </div>
            <vs-select
              ref="selectPattern"
              :data="names"
              :header="{label:'name'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="selectedProductPattern"
            ></vs-select>
          </div>

        </div>
        <div class="col-2">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <span class="input-group-text">تعداد</span>
            </div>
            <input class="form-control" type="number" placeholder="تعداد مورد نظر" v-model="createPatternModel.count"/>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>اولویت</span>
              </div>
            </div>

            <vs-select
              ref="selectedPriority"
              :isHeader="true"
              :data="priority"
              :selectedVal="priority.title"
              :header="{label:'title'}"
              :mode="'edit'"
              @dataChanged="priorityTitleSelect"
              style="max-width:50% !important; "
            ></vs-select>
            <!--v-if="!sellOnly && mode!=='view'"-->
          </div>
        </div>
        <!--<div class="row">-->
        <div class="input-group col-sm-12 mt-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>دستورات کار </span>
            </div>
          </div>
          <input type="text" class="form-control" v-model="workDescription">
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>

      <!--</div>-->
    </b-modal>

  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import EventBus from "../../bus.js";
  import axios from "axios";

  export default {
    name: 'inventory-details',
    props: ['row'],
    components: {
      VsSelect
    },
    data() {
      return {
        names: [],
        selectedProductPattern: null,
        model: null,
        showModal: true,
        patterns: null,
        createPatternModel: {
          patternId: 0,
          count: 0,
          orderDetailId: 0
        },
        worksCount: 0,
        workDescription: "",
        priority: [],
        selectedPriority:0,
      }
    },
    mounted() {
      // new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
      //   this.priority = response.data;
      //
      //   // console.log(response.data)
      // }).catch((error) => {
      //   console.log(error)
      // });
      this.refreshTable();
      setTimeout(() => {
        // this.getOrderList();
        this.calculateWorksCount();
      }, 500)

    },
    methods: {
      refreshTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
        // this.$refs.table.onFetchEntityList();
      },
      calculateWorksCount() {
        // console.log(this.row.worksCount);
        this.createPatternModel.count = this.row.unitVal;
        this.worksCount = this.row.worksCount;

        if (this.row.worksCount) {
          // console.log(this.row.worksCount);
          this.createPatternModel.count -= this.worksCount;
        }
        if (this.createPatternModel.count <= 0) {
          this.createPatternModel.count = 0;
        }
      },
      /* onMaterialModalOk() {
         this.$emit(
           "dataChanged",
           this.headerKey,
           this.vsTableFeed.map(m => {
             return m;
           })
         );
         if (this.mode !== "create") {
           EventBus.$emit("materialChanged");
         }
       },*/
      onTaminClicked(id){
        this.$router.push({
          path: "/supply/" + id
        });
      },
      getPatterns(id) {

        new BaseService('Patterns', `/GetProductPatterns/${id}`).getList().then((response) => {
          this.names = response.data;

          if (this.names.length <= 0) {
            this.showModal = false;
            this.$noty.warning("این محصول الگویی برای تولید ندارد")
            // console.log(this.showModal)
          }
          this.$refs['productOrder'].show()
        }).catch((error) => {
          console.log(error)
        }).then(() => {

        });
      },
      getOrderList() {
        new BaseService('ProductionManagements', '/GetManageOrder').getList().then((response) => {
          this.refreshTable()
        }).catch((error) => {
          console.log(error)
        });
      },
      sendOrderToProduce() {
        let model = {
          patternId: this.$refs.selectPattern.selectedValue.id,
          count: parseInt(this.createPatternModel.count),
          orderDetailId: this.row.id,
          description: this.workDescription,
          priority : this.selectedPriority,
        };
        new BaseService('Works', '/CreateWorkFromOrder').create(model).then((response) => {
          // console.log("ok button clicked");
          this.$noty.success("سفارش به خط تولید ارسال شد");
          this.$refs.selectPattern.$data.selectedValue = null;
          this.worksCount += parseInt(this.createPatternModel.count);

          // this.getOrderList();
          this.refreshTable();
          this.calculateWorksCount();
        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });

      },
      priorityTitleSelect(prop, data) {
        this.selectedPriority = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
    }
  }

</script>

<style scoped lang="scss">
  .black {
    color: black;
  }
</style>
